import { FokParameterType } from '../../types';

export const isPensionParameter = (fokParameterValue: string) => {
  return (
    fokParameterValue === FokParameterType.KPAfter65 || fokParameterValue === FokParameterType.AvtalspensionSAFLOAfter65
  );
};
